export default __webpack_public_path__ + "static/media/uniswap-logo.6ae3efa2.svg";